package br.com.heyagenda.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import br.com.heyagenda.ui.theme.AuraBackground

@Composable
fun PublicBookingSkeleton(
    modifier: Modifier = Modifier
) {
    Box(
        modifier = modifier
            .fillMaxSize()
            .background(AuraBackground)
    ) {
        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(16.dp),
            verticalArrangement = Arrangement.spacedBy(16.dp)
        ) {
            // Header Card Skeleton
            AuraCard(
                modifier = Modifier.fillMaxWidth(),
                cornerRadius = 24.dp
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(20.dp),
                    verticalArrangement = Arrangement.spacedBy(14.dp)
                ) {
                    // Announcement Pill Placeholder
                    AuraShimmerBox(height = 32.dp, shape = RoundedCornerShape(12.dp))

                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.SpaceBetween,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.spacedBy(14.dp)
                        ) {
                            Box(
                                modifier = Modifier
                                    .size(52.dp)
                                    .clip(CircleShape)
                                    .auraShimmer(CircleShape)
                            )

                            Column(verticalArrangement = Arrangement.spacedBy(6.dp)) {
                                AuraShimmerBox(width = 160.dp, height = 20.dp, shape = RoundedCornerShape(6.dp))
                                AuraShimmerBox(width = 110.dp, height = 13.dp, shape = RoundedCornerShape(4.dp))
                                AuraShimmerBox(width = 80.dp, height = 12.dp, shape = RoundedCornerShape(4.dp))
                            }
                        }

                        Box(
                            modifier = Modifier
                                .size(34.dp)
                                .clip(CircleShape)
                                .auraShimmer(CircleShape)
                        )
                    }

                    AuraShimmerBox(width = 140.dp, height = 22.dp, shape = CircleShape)
                }
            }

            // Catalog Section Title Skeleton
            Column(verticalArrangement = Arrangement.spacedBy(6.dp)) {
                AuraShimmerBox(width = 200.dp, height = 18.dp, shape = RoundedCornerShape(6.dp))
                AuraShimmerBox(width = 280.dp, height = 12.dp, shape = RoundedCornerShape(4.dp))
            }

            // Service Cards Skeletons
            repeat(3) {
                AuraCard(
                    modifier = Modifier.fillMaxWidth(),
                    cornerRadius = 20.dp
                ) {
                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(16.dp),
                        verticalArrangement = Arrangement.spacedBy(12.dp)
                    ) {
                        Row(
                            modifier = Modifier.fillMaxWidth(),
                            horizontalArrangement = Arrangement.SpaceBetween,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Column(verticalArrangement = Arrangement.spacedBy(6.dp)) {
                                AuraShimmerBox(width = 150.dp, height = 16.dp, shape = RoundedCornerShape(4.dp))
                                AuraShimmerBox(width = 90.dp, height = 12.dp, shape = RoundedCornerShape(4.dp))
                            }
                            AuraShimmerBox(width = 70.dp, height = 18.dp, shape = RoundedCornerShape(6.dp))
                        }

                        AuraShimmerBox(height = 12.dp, shape = RoundedCornerShape(4.dp))

                        Row(
                            modifier = Modifier.fillMaxWidth(),
                            horizontalArrangement = Arrangement.End
                        ) {
                            AuraShimmerBox(width = 100.dp, height = 34.dp, shape = CircleShape)
                        }
                    }
                }
            }
        }
    }
}
